import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesDataStatus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <circle
      style={{
        fill: "#1a699e",
      }}
      cx={7.5}
      cy={7.5}
      r={6.5}
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#fff",
      }}
      d="M7 4h1v5H7zM7 10h1v1H7z"
    />
  </svg>
);
const Memo = memo(SvgSpacesDataStatus);
export default Memo;
